"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BindingCount = void 0;
var BindingCount;
(function (BindingCount) {
    BindingCount[BindingCount["MultipleBindingsAvailable"] = 2] = "MultipleBindingsAvailable";
    BindingCount[BindingCount["NoBindingsAvailable"] = 0] = "NoBindingsAvailable";
    BindingCount[BindingCount["OnlyOneBindingAvailable"] = 1] = "OnlyOneBindingAvailable";
})(BindingCount || (exports.BindingCount = BindingCount = {}));
